import React from 'react';
import {useTranslation} from 'react-i18next';
import {ETooltip} from 'webapp-lib/Components';
import {ConditionalWrapper} from 'webapp-lib/utils';

import i18n from '_/i18n';
import {NOT_FOUND} from '_/utilities/string';

export type DateFormat =
  | 'withTime'
  | 'withoutTime'
  | 'withoutTimeAndTwoDigitYear'
  | 'withTimeAndTwoDigitYear';

export const FormattedDate = ({
  dateAsString,
  format,
  enableTimeDetailsTooltip = false,
}: {
  dateAsString: string | undefined;
  format: DateFormat;
  enableTimeDetailsTooltip?: boolean;
}): React.ReactElement => {
  const {t} = useTranslation('common');

  if (!dateAsString) {
    return <>{NOT_FOUND}</>;
  }

  const date = new Date(dateAsString);
  return (
    <ConditionalWrapper
      condition={Boolean(enableTimeDetailsTooltip)}
      wrapper={(child) => (
        <ETooltip title={t('dateFormat.withTimeAndSeconds', {date})}>
          {child}
        </ETooltip>
      )}
    >
      <span>{DATE_TRANSLATIONS[format](date)}</span>
    </ConditionalWrapper>
  );
};

const DATE_TRANSLATIONS: Record<DateFormat, (date: Date) => string> = {
  withTime: (date: Date) => i18n.t('dateFormat.withTime', {date}),
  withoutTime: (date: Date) => i18n.t('dateFormat.withoutTime', {date}),
  withTimeAndTwoDigitYear: (date: Date) =>
    i18n.t('dateFormat.withTimeAndTwoDigitYear', {date}),
  withoutTimeAndTwoDigitYear: (date: Date) =>
    i18n.t('dateFormat.withoutTimeAndTwoDigitYear', {date}),
};
